import { useMutation } from '@tanstack/react-query';
import { publicApi } from '@/services/api';

export interface ContactFormPayload {
    name: string;
    email: string;
    phone?: string;
    subject?: string;
    message: string;
}

export function useSubmitContactForm() {
    return useMutation({
        mutationFn: async (payload: ContactFormPayload) => {
            const { data } = await publicApi.post<{ success: boolean; message: string }>('/contact-messages', payload);
            return data;
        },
    });
}
